import { CamAuth0Environment } from '@camelot/user';

export const baseEnvironment: {
  production: boolean;
  AUTH0: CamAuth0Environment;
  version: string;

  TENANT_ID: number | null;
  TENANT_NAME: string;
  DEBUG: boolean;
  DEBUG_LEVEL: number;

  LOCAL: boolean;
  IS_CUSTOMER_APPLICATION: boolean;

  STRAPI_SERVER_CONFIG: {
    url: string;
    token: string;
  };

  GRAPHQL_SERVER_CONFIG: {
    url: string;
    local_urls: {
      user: string;
    };
  };
  PENDINGREQUESTAPI: number;
  SERVER_TYPE: string;
  APIEXT: string;
  SERVER_URL: string;
  SUPPORTURL: string;
  WORKER_SUPPORTURL: string;
  GTM: string;

  APP_NAME: string;
  MAIN_COLOR: string;
  PWAACTIVE: boolean;

  INSTALLATION_URL: {
    IOS: string;
    ANDROID: string;
  };

  TRANSLATION: {
    DEFAULT: string;
    SUPPORTEDLANGUAGES: string[];
  };
} = {
  production: false,
  version: require('../../package.json').version,

  TENANT_NAME: 'default',
  TENANT_ID: 999000,
  DEBUG: false,
  DEBUG_LEVEL: 0,

  LOCAL: false,
  IS_CUSTOMER_APPLICATION: false,

  STRAPI_SERVER_CONFIG: {
    url: 'https://cms-test.merlinsoftware.be/graphql',
    token:
      '26392b7e68bcaf00a7a1ab8a124957c3b3fa81d92c3cefcc89ed60734d409b8696734c7f718769243106c9617f84cc574a5219b9282b4c13f770158be82b20d391351aa0f352e3f5e5ecd7d5f326ae9baba4b0ae8232eef17f20058e4bb92de41273762111ea5f8f84fe258eb718d6e862eea5f7c8186388ce28810a39f27b69',
  },

  GRAPHQL_SERVER_CONFIG: {
    url: '',
    local_urls: {
      user: '',
    },
  },
  PENDINGREQUESTAPI: 5,
  SERVER_TYPE: 'API',
  APIEXT: '',
  SERVER_URL: '',
  SUPPORTURL: '',
  WORKER_SUPPORTURL: '',
  GTM: '',

  APP_NAME: 'Merlin app',
  MAIN_COLOR: 'white',
  PWAACTIVE: true,

  INSTALLATION_URL: {
    IOS: '',
    ANDROID: '',
  },
  AUTH0: {
    domain: '',
    clientId: '',
    cacheLocation: 'localstorage',
    // Request this audience at user authentication time
    authorizationParams: {
      audience: '',
      redirect_uri: window.location.origin,
    },

    // Specify configuration for the interceptor
    httpInterceptor: {
      allowedList: [
        {
          uri: '',
        },
      ],
    },
  },

  TRANSLATION: {
    DEFAULT: 'fr',
    SUPPORTEDLANGUAGES: ['fr', 'en', 'nl', 'es'],
  },
};
